<template>
  <section>
    <b-tabs v-model="activeTab">

      <b-tab-item label="Carriers">
        Coming soon
      </b-tab-item>

      <b-tab-item label="Missing carrier documents">
        <carrier-document-table />
      </b-tab-item>

      <b-tab-item label="Shippers">
        Coming soon
      </b-tab-item>

      <b-tab-item label="Transactions">
        Coming soon
        <transaction-table :auto-update="false" :company-jobs="[]" />
      </b-tab-item>

    </b-tabs>
  </section>

</template>

<script>
import CarrierDocumentTable from '@/components/Admin-CarrierDocumntUpload'
import TransactionTable from '@/components/TransactionsTable'
export default {
  name: 'TrucklAdminDashboard',

  data() {
    return {
      activeTab: 1
    }
  },

  components: {
    CarrierDocumentTable,
    TransactionTable
  }
}
</script>

<style scoped>
</style>
